/**
 * Flags when snapshot reseed leaves a recovery-backup that failed to merge,
 * or succeeded — used to block hard-refresh wipe until export.
 */

const LS_RECOVERY_MERGE_FAILED_KEY = 'esan:sqlite:recovery-merge-failed';
const LS_RECOVERY_BACKUP_PRESENT_KEY = 'esan:sqlite:recovery-backup-present';

function lsSet(key: string, value: string): void {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    /* private mode */
  }
}

function lsGet(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function lsRemove(key: string): void {
  try {
    globalThis.localStorage?.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function markRecoveryMergeFailed(message?: string): void {
  lsSet(LS_RECOVERY_MERGE_FAILED_KEY, message?.trim() || '1');
  lsSet(LS_RECOVERY_BACKUP_PRESENT_KEY, '1');
}

export function markRecoveryBackupPresent(): void {
  lsSet(LS_RECOVERY_BACKUP_PRESENT_KEY, '1');
}

export function clearRecoveryMergeFailed(): void {
  lsRemove(LS_RECOVERY_MERGE_FAILED_KEY);
}

export function clearRecoveryBackupPresent(): void {
  lsRemove(LS_RECOVERY_BACKUP_PRESENT_KEY);
  lsRemove(LS_RECOVERY_MERGE_FAILED_KEY);
}

export function isRecoveryMergeFailed(): boolean {
  return lsGet(LS_RECOVERY_MERGE_FAILED_KEY) != null;
}

export function isRecoveryBackupPresent(): boolean {
  return lsGet(LS_RECOVERY_BACKUP_PRESENT_KEY) === '1';
}

export function recoveryMergeFailedBannerMessage(): string | null {
  if (!isRecoveryMergeFailed()) return null;
  return 'Hay un respaldo local de registros que no se pudo restaurar automáticamente. Exporte en Observabilidad antes de borrar datos o actualizar con limpieza.';
}

/** Hard refresh must not wipe SQLite while recovery backup / failed merge is outstanding. */
export function shouldBlockHardRefreshClearIdb(): boolean {
  return isRecoveryMergeFailed() || isRecoveryBackupPresent();
}

export function resetRecoveryMergeFlagsForTests(): void {
  clearRecoveryBackupPresent();
}
